import React, { useCallback } from 'react';
import { Detection } from "@/store/detection-slice";
import { Card } from "./ui/card";
import { useStore } from '@/store/store';

interface DroneTrackingBoxProps {
  drone: Detection;
  isTracked: boolean;
}

export const DroneTrackingBox: React.FC<DroneTrackingBoxProps> = ({ drone, isTracked }) => {
  // Parse drone details if available
  const droneDetails = typeof drone.drone_details === 'string' 
    ? JSON.parse(drone.drone_details) 
    : drone.drone_details;


  const mapStyle = useStore(useCallback((state) => state.mapStyle, []));
  return (
    <Card className={`
      absolute 
      left-8 
      -top-2 
      p-2 
      min-w-[200px] 
      bg-background/30 
      backdrop-blur-sm 
      shadow-lg 
      border
      ${mapStyle === 'Dark' ? 'text-white' : 'text-black'}
      text-xs
      ${isTracked ? 'border-blue-500' : 'border-gray-200'}
    `}>
      <div className="space-y-1">
        <div className="font-medium">
          ID: {drone.drone_identifier}
        </div>
        <div className={`${mapStyle === 'Dark' ? 'text-white' : 'text-black'}`}>
          <div>Lat: {drone.latitude.toFixed(6)}</div>
          <div>Long: {drone.longitude.toFixed(6)}</div>
          <div>Time: {new Date(drone.detection_time).toLocaleTimeString()}</div>
          {droneDetails && (
            <>
              {droneDetails.altitude && (
                <div>Alt: {droneDetails.altitude}m</div>
              )}
              {droneDetails.speed && (
                <div>Speed: {droneDetails.speed}m/s</div>
              )}
              {droneDetails.heading && (
                <div>Heading: {droneDetails.heading}</div>
              )}
            </>
          )}
        </div>
      </div>
    </Card>
  );
}; 